<template>
  <v-card class="mb-2">
    <v-card-text>
      <v-layout row wrap>
        <v-flex xs12 md4 lg2>
          <v-card flat class="mb-3" height="200px">
            <v-card-title class="subheader">Portfolio</v-card-title>
            <v-card-text class="pb-0">
              <file-input v-model="picture" block :config="{
                path: 'portfolio',
                label: $t('inputs.portfolio.labels.picture')
              }"></file-input>
            </v-card-text>
            <v-card-text>
              <v-dialog v-model="videoPopup">
                <v-btn outline block primary slot="activator">{{ $t('inputs.portfolio.labels.video') }}</v-btn>
                <v-card>
                  <v-card-title>{{ $t('inputs.portfolio.labels.picture') }}</v-card-title>
                  <v-card-text>
                    <p>{{ $t('inputs.portfolio.video.text') }}</p>
                    <v-text-field :label="$t('inputs.portfolio.video.url')" v-model="video" />
                  </v-card-text>
                  <v-card-row actions>
                    <v-btn outline primary @click.native="submitVideo">{{ $t('inputs.portfolio.video.button') }}</v-btn>
                  </v-card-row>
                </v-card>
              </v-dialog>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex xs12 md4 lg2 v-for="(item, i) in value" :key="i">
          <v-card
            v-if="item.type === 'picture'"
            class="mb-3"
            :img="item.src"
            height="200px"
            style="width:200px">
            <v-btn class="delete" @click.native="remove(i)" icon><v-icon>close</v-icon></v-btn>
          </v-card>
          <v-card
            v-if="item.type === 'video'"
            class="mb-3"
            :img="item.src"
            height="200px"
            style="width:200px">
            <v-btn class="delete" @click.native="remove(i)" icon><v-icon>close</v-icon></v-btn>
            <v-layout row justify-center align-center fill-height>
              <v-flex xs12 class="text-xs-center">
                <a :href="item.src" target="_blank">
                  <v-icon x-large>play_arrow</v-icon>
                </a>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
    </v-card-text>
  </v-card>
</template>

<script>
import FileInput from './File'
export default {
  components: {
    FileInput
  },
  props: {
    value: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      picture: null,
      video: null,
      videoPopup: false
    }
  },
  watch: {
    picture () {
      if (!this.picture) { return }
      this.$emit('input', [
        ...this.value,
        { type: 'picture', src: this.picture }
      ])
      this.picture = null
    }
  },
  methods: {
    remove (index) {
      this.$emit('input', [...this.value.filter((x, i) => i !== index)])
    },
    submitVideo () {
      this.videoPopup = false
      if (!this.video) { return }
      this.$emit('input', [
        ...this.value,
        { type: 'video', src: this.video }
      ])
      this.video = null
    }
  }
}
</script>

<style scoped>
  .delete {
    position: absolute;
    right: 0;
    background: white;
  }
</style>



// WEBPACK FOOTER //
// src/components/inputs/Portfolio.vue